//= FIXME: Copied over from marketing-landing-page
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

export default function() {
    function videoResize() {
        if ($(window).width() > 800) {
            $('.modal--the-video__video').css({
                left: '50%',
                'margin-left': '-350px',
                'margin-top': '-200px',
                position: 'absolute',
                top: '50%',
                width: '700px',
                height: '389px',
            });
        } else {
            $('.modal--the-video__video').css({
                left: '0',
                'margin-left': '0',
                'margin-top': '0',
                position: 'absolute',
                top: '0',
                width: $(window).width(),
                height: $(window).height(),
            });
        }
    }

    $(window).on('resize', videoResize);

    $(function() {
        //setup modal here to override anything in css this is temporary and
        //styles are in js to keep this separate for now.
        $('.modal--the-video').css({
            height: '100%',
            position: 'fixed',
            top: '0',
            width: '100%',
            'z-index': '11',
            'background-color': 'rgba(28, 27, 26, 0.5)',
            display: 'none',
        });

        videoResize();

        var video = null;
        var videoId = null;

        function callVideo() {
            $('#modalTheVideo' + videoId).show();
            video = $('#theVideo' + videoId) ? $('#theVideo' + videoId)[0] : null;
            video.load();
            video.play();
        }

        $('[data-video-button]').on('click', function(e) {
            e.preventDefault();
            var videoSrc = $(this).attr('href');
            videoId = $(this).data('video-modal-id');

            $('[data-video-modal-video-id="' + videoId + '"] source').attr('src', videoSrc);

            callVideo();
        });

        $('.modal--the-video').on('click', function(e) {
            if (e.target && e.target.id === `modalTheVideo${videoId}`) {
                video.pause();
                $('#modalTheVideo' + videoId).hide();
            }
        });
        $('.modal--the-video .btn--close').on('click', function() {
            $('.modal--the-video').hide();
            video.pause();
        });
    });
}
